import React, {
  useState,
  useCallback,
  useEffect,
  Fragment,
  useContext,
} from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import PageHeader from '../../../layouts/shared/headers/PageHeader/PageHeader';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Grid,
  Paper,
  Stack,
  useMediaQuery,
  Typography,
  Button,
  Box,
  Pagination,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select as MuiSelect,
  TextField
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import * as yup from 'yup';
import { ApiService } from 'app/servicesTwo/ApiService';
import JumboSearch from '@jumbo/components/JumboSearch';
import JumboSearchWithoutDebounce from "@jumbo/components/JumboSearchWithoutDebounce";
import { Link, useLocation } from 'react-router-dom';
import { PermissionContext } from 'app/contexts/PermissionContext';
import makeAnimated from 'react-select/animated';
import Select from 'react-select';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';
import BookItem from './BookItem';

const BookList = () => {
  const { theme } = useJumboTheme();
  const animatedComponents = makeAnimated();
  const location = useLocation();
  const Swal = useSwalWrapper();
  const lg = useMediaQuery(theme.breakpoints.down('lg'));
  const { hasPermission } = useContext(PermissionContext);

  const [books, setBooks] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(true);
  const [select1Value, setSelect1Value] = useState(null);
  const [page, setPage] = useState(1);
  const [per_page, setPerPage] = useState(10);
  const [count, setCount] = useState(0);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [selectedBookCodes, setSelectedBookCodes] = useState([]);
  const [bookCodesOptions, setBookCodesOptions] = useState([]);

  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: {
            display: 'none',
          },
        },
      },
      wrapper: {
        sx: {
          alignItems: 'flex-start',
        },
      },
    }),
    [theme]
  );

  const getBooks = useCallback(async (searchData = {}) => {
    setLoading(true);
    try {
      const response = await ApiService.get('/livros', {
        params: {
          ...searchData,
          departament: searchData.departament || selectedDepartment?.value,
          codigo_do_livro: searchData.codigo_do_livro && searchData.codigo_do_livro.length > 0
            ? searchData.codigo_do_livro.map(item => item.value)
            : [],
        },
      });
      console.log('resoinse', response.data);
      setBooks(response.data?.books);
      setCount(response.data?.total_pages);
    } catch (error) {
      console.error('Error fetching books:', error);
    } finally {
      setLoading(false);
    }
  }, [selectedBookCodes, selectedDepartment]);

  const getDepartments = async () => {
    try {
      const response = await ApiService.get('/departamentos');
      const formattedDepartments = response.data.map(dept => ({ value: dept.departamento_id, label: dept.nome }));

      setDepartments([{ value: '', label: 'Sem seleção' }, ...formattedDepartments]);
    } catch (error) {
      console.error('Error fetching departments:', error);
    }
  };

    const getBookCodes = async () => {
        try {
            const response = await ApiService.get('/livros', { params: { per_page: 10000 } });
             if (response.data && response.data.books) {
                 const codes = response.data.books.map(book => ({
                     value: book.codigo_do_livro,
                     label: book.codigo_do_livro
                 }));
                 const uniqueCodes = Array.from(new Set(codes.map(a => a.value)))
                 .map(value => {
                   return codes.find(a => a.value === value)
                 })

                setBookCodesOptions(uniqueCodes);
             }
        } catch (error) {
            console.error('Error fetching book codes:', error);
        }
    };

  useEffect(() => {
    const selectedValueToString = JSON.stringify(select1Value);
    
    getBooks({ 
        search: searchTerm, 
        page, 
        per_page, 
        selectedValueToString, 
        departament: selectedDepartment?.value,
        codigo_do_livro: selectedBookCodes 
    });
  }, [page]);

  useEffect(() => {
    getDepartments();
    getBookCodes();
  }, []);

  useEffect(() => {
    Swal.close();
  }, [location.pathname, Swal]);

  const handleSelect1Change = (selected) => {
    setSelect1Value(selected.length === 0 ? null : selected);
  };

  const optionsYears = () => {
    const startYear = 1980;
    const endYear = new Date().getFullYear();
    return Array.from({ length: endYear - startYear + 3 }, (_, i) => ({
      value: endYear + 2 - i,
      label: (endYear + 2 - i).toString(),
    }));
  };

  const handleSubmit = () => {

    const searchData = {
      search: searchTerm,
      page,
      per_page,
      departament: selectedDepartment?.value,
      codigo_do_livro: selectedBookCodes
    };
    setLoading(true);
    getBooks(searchData);
  };

  return (
    <JumboContentLayout
      header={<PageHeader title={'Livros (Equipe)'} />}
      layoutOptions={layoutOptions}
    >
      {lg && (
        <Stack spacing={2} direction={'row'} sx={{ mb: 3, mt: -2 }}></Stack>
      )}
      <Paper sx={{ p: '40px' }}>
        {!location.pathname.includes('inserir') && (
          <Box display='flex' justifyContent='center'>
            <Link
              to='/app/nova-equipe'
              style={{
                textDecoration: 'none',
                pointerEvents: !hasPermission('Livros (Equipe)', 'criar') ? 'none' : '',
              }}
              state={{ backUrl: location.pathname }}
            >
              <LoadingButton
                color='success'
                type='submit'
                variant='contained'
                size='large'
                disabled={!hasPermission('Livros (Equipe)', 'criar')}
                sx={{
                  maxWidth: { md: '250px', mt: '1rem' },
                  marginBottom: '2rem',
                }}
              >
                Novo Livro (Equipe)
              </LoadingButton>
            </Link>
          </Box>
        )}

        <Box
          display='flex'
          alignItems='center'
          gap='1rem'
          marginBottom='1rem'
          flexWrap='wrap'
        >
          <Box
            display='flex'
            alignItems='center'
            gap='1rem'
            marginBottom='1rem'
            flexWrap='wrap'
          >
           <Box sx={{ width: '300px' }}>
              <Select
                isMulti
                options={bookCodesOptions}
                value={selectedBookCodes}
                onChange={(selected) => setSelectedBookCodes(selected)}
                components={animatedComponents}
                placeholder='Selecione códigos de livro'
                styles={{
                  menu: (list) => ({
                    ...list,
                    zIndex: 3,
                  }),
                  control: (base) => ({
                    ...base,
                    width: '100%',
                  }),
                }}
              />
           </Box>
            <Select
              id='select-one'
              options={departments}
              value={selectedDepartment}
              onChange={(selected) => setSelectedDepartment(selected)}
              components={animatedComponents}
              placeholder='Selecione departamento/trabalho'
              styles={{
                menu: (list) => ({
                  ...list,
                  zIndex: 3,
                }),
                control: (base) => ({
                  ...base,
                  width: '300px',
                }),
              }}
            />
            <Button variant={'contained'} onClick={handleSubmit}>
              Filtrar
            </Button>
          </Box>

          {/* <Box display='flex' alignItems='center' gap='1rem'>
            <Select
              id='select-one'
              isMulti
              options={optionsYears()}
              value={select1Value}
              onChange={handleSelect1Change}
              components={animatedComponents}
              placeholder='Selecione ano'
              styles={{
                menu: (list) => ({
                  ...list,
                  zIndex: 3,
                }),
                control: (base) => ({
                  ...base,
                  width: '100%',
                }),
                }}
             />
            <Button variant={'contained'} onClick={handleSubmit}>
              Filtrar
            </Button>
          </Box> */}

          {/* <Box display='flex' alignItems='center' width='40%'>
            <JumboSearch
              onChange={(e) => setSearchTerm(e)}
              placeholder='Busque por outros termos...'
            />
          </Box> */}
        </Box>

        <Fragment>
          {loading ? (
            <Box display='flex' justifyContent='center'>
              <CircularProgress />
            </Box>
          ) : (
            <>
              {books &&
                books.map((user, key) => (
                  <BookItem
                    item={user}
                    setBooks={(data) => setBooks([...data])}
                    books={books}
                    key={key}
                  />
                ))}
              {books && books.length === 0 && (
                <Typography>Sem resultados correspondentes</Typography>
              )}
            </>
          )}
        </Fragment>
        <Pagination
          sx={{ mt: 2 }}
          color='primary'
          count={count}
          page={page}
          onChange={(event, value) => setPage(value)}
        />
      </Paper>
    </JumboContentLayout>
  );
};

export default BookList;
